export default __webpack_public_path__ + "static/media/adp-04.d462cea6.png";